import React from "react";
import Button from "./Button";


const cards = [
    {
        id: 1,
        img: require("../../images/pexels-terry-magallanes-3623785.jpg"),
        title: 'Kitchen',
        details: 'If a dog chews shoes whose shoes does he choose?',
        button: <Button text="READ MORE" />
    },
    {
        id: 2,
        img: require("../../images/pexels-max-vakhtbovych-7587873.jpg"),
        title: 'Bathroom',
        details: 'If a dog chews shoes whose shoes does he choose?',
        button: <Button text="READ MORE" />
    },
    {
        id: 3,
        img: require("../../images/pexels-alexas-fotos-7616004.jpg"),
        title: 'Water Line',
        details: 'If a dog chews shoes whose shoes does he choose?',
        button: <Button text="READ MORE" />
    },
    {
        id: 4,
        img: require("../../images/pexels-laurie-shaw-804392.jpg"),
        title: 'Basement',
        details: 'If a dog chews shoes whose shoes does he choose?',
        button: <Button text="READ MORE" />
    },
    {
        id: 5,
        img: require("../../images/pexels-jeshootscom-834892.jpg"),
        title: 'Remodeling',
        details: 'If a dog chews shoes whose shoes does he choose?',
        button: <Button text="READ MORE" />
    },

    {
        id: 6,
        img: require("../../images/pexels-jeshootscom-834892.jpg"),
        title: 'Remodeling',
        details: 'If a dog chews shoes whose shoes does he choose?',
        button: <Button text="READ MORE" />
    },
]

export default cards;

